export default __webpack_public_path__ + "static/media/natural-1281596-removebg-preview (1).ff2a4bb3.png";